/* bristm-case-studies — listing section script (loaded only where the section renders)
 *  - "Load more": fetches the next page through the Section Rendering API and
 *    appends the cards (the button is a real pagination link without JS)
 *  - Fallback blocks: client-side filtering by the Service / Industry chips
 *  All works | Services | Industries switching is CSS-only (radio inputs +
 *  :has()); with fallback blocks, "All works" also resets the filter.
 */
(function () {
  'use strict';

  function updateStatus(root, count) {
    var foot = root.querySelector('[data-b-cases-total]');
    var status = root.querySelector('[data-b-cases-status]');
    if (!foot) return;
    var total = parseInt(foot.getAttribute('data-b-cases-total'), 10) || count;
    if (status) {
      var tpl = status.getAttribute('data-template') || '';
      status.textContent = tpl.replace('[count]', count).replace('[total]', total);
    }
    foot.style.setProperty('--b-cases-progress', total ? Math.min(count / total, 1) : 1);
  }

  function cleanUrl(href) {
    var url = new URL(href, window.location.href);
    url.searchParams.delete('section_id');
    return url;
  }

  function loadMore(root, link) {
    if (link.classList.contains('is-loading')) return;
    var grid = root.querySelector('[data-b-cases-grid]');
    if (!grid || !window.fetch || !window.DOMParser) {
      window.location.href = link.href;
      return;
    }

    var url = cleanUrl(link.href);
    var view = new URLSearchParams(window.location.search).get('view');
    if (view && !url.searchParams.has('view')) url.searchParams.set('view', view);
    url.searchParams.set('section_id', root.getAttribute('data-section-id'));

    link.classList.add('is-loading');
    link.setAttribute('aria-busy', 'true');

    fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelectorAll('[data-b-cases-grid] > [data-b-cases-card]');
        var frag = document.createDocumentFragment();
        var first = null;
        fresh.forEach(function (card) {
          var node = document.importNode(card, true);
          if (!first) first = node;
          frag.appendChild(node);
        });
        grid.appendChild(frag);

        var next = doc.querySelector('[data-b-cases-more]');
        if (next) {
          link.href = cleanUrl(next.getAttribute('href')).toString();
        } else {
          link.remove();
        }

        updateStatus(root, grid.children.length);
        if (window.BRISTM && window.BRISTM.init) window.BRISTM.init(grid);
        if (first) {
          var a = first.querySelector('a');
          if (a) a.focus({ preventScroll: true });
        }
      })
      .catch(function () {
        window.location.href = link.href;
      })
      .then(function () {
        link.classList.remove('is-loading');
        link.removeAttribute('aria-busy');
      });
  }

  /* Fallback blocks: filter the static cards by chip (no network) */
  function bindLocalFilter(root, grid) {
    var cards = Array.prototype.slice.call(grid.children);

    function applyFilter(value, btn) {
      root.querySelectorAll('[data-b-cases-filter]').forEach(function (b) {
        var isAll = b.getAttribute('data-b-cases-filter') === 'all';
        var on = btn ? b === btn || (value === 'all' && isAll) : isAll;
        b.setAttribute('aria-pressed', String(on));
      });

      var matching = cards.filter(function (card) {
        if (value === 'all') return true;
        var terms = ' ' + (card.getAttribute('data-b-cases-terms') || '') + ' ';
        return terms.indexOf(' ' + value + ' ') > -1;
      });

      // Re-insert in original order
      matching.forEach(function (card) {
        card.classList.remove('is-filtered-in');
        card.classList.add('is-revealed');
      });
      grid.replaceChildren.apply(grid, matching);
      void grid.offsetWidth; // restart the entrance animation once for all cards
      matching.forEach(function (card) {
        card.classList.add('is-filtered-in');
      });

      updateStatus(root, matching.length);
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-b-cases-filter]');
      if (!btn || !root.contains(btn)) return;
      applyFilter(btn.getAttribute('data-b-cases-filter'), btn);
    });

    // "All works" tab shows every case again
    root.addEventListener('change', function (e) {
      var radio = e.target;
      if (!radio.classList || !radio.classList.contains('b-cases__radio')) return;
      if (radio.value === 'all' && grid.children.length !== cards.length) applyFilter('all');
    });
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var roots = host.matches && host.matches('[data-b-cases]') ? [host] : host.querySelectorAll('[data-b-cases]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.bCasesBound) return;
      root.dataset.bCasesBound = '1';

      var grid = root.querySelector('[data-b-cases-grid]');
      if (grid && grid.hasAttribute('data-b-cases-local')) bindLocalFilter(root, grid);

      root.addEventListener('click', function (e) {
        var link = e.target.closest && e.target.closest('[data-b-cases-more]');
        if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
        e.preventDefault();
        loadMore(root, link);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
